/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ProcedureInvestigation from './procedure-investigation';
import ProcedureInvestigationDetail from './procedure-investigation-detail';
import ProcedureInvestigationUpdate from './procedure-investigation-update';
import ProcedureInvestigationDeleteDialog from './procedure-investigation-delete-dialog';

const ProcedureInvestigationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ProcedureInvestigation />} />
    <Route path="new" element={<ProcedureInvestigationUpdate />} />
    <Route path=":id">
      <Route index element={<ProcedureInvestigationDetail />} />
      <Route path="edit" element={<ProcedureInvestigationUpdate />} />
      <Route path="delete" element={<ProcedureInvestigationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ProcedureInvestigationRoutes;
